import {createQueryKeys} from '@lukemorales/query-key-factory'
import {api} from 'api'
import type {ListPlannerProps} from 'api/parts/planner'
import {queryKeysFromParams} from './queryKeysFromParams'

export const planner = createQueryKeys('planner', {
  list: (props: ListPlannerProps) => ({
    queryKey: queryKeysFromParams(props),
    queryFn: () => api.planner.list(props),
  }),
})
